import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import digi from "@core/assets/icons/digi.svg?raw";
import integration from "@core/assets/icons/integration.svg?raw";
import pc from "@core/assets/icons/pc.svg?raw";
import rentIt from "@core/assets/icons/rent-it.svg?raw";
import rescue from "@core/assets/icons/rescue.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";
import { getEmbeddedSoftwarePath } from "@core/schema/paths/getEmbeddedSoftwarePath.js";
import { getHireItTeamPath } from "@core/schema/paths/getHireItTeamPath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";
import { getWebsitesPath } from "@core/schema/paths/getWebsitesPath.js";

export function getServicesRescue(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "Webové aplikace",
			iconName: brackets,
			show: true,
			href: getWebAppsPath(tenant),
		},
		{
			title: "Mobilní aplikace",
			iconName: rentIt,
			href: "#",
			show: false,
		},
		{
			title: "IT konzultace",
			iconName: rescue,
			href: "#",
			show: false,
		},
		{
			title: "Pronájem IT týmu",
			iconName: pc,
			show: true,
			href: getHireItTeamPath(tenant),
		},
		{
			title: "Vývoj cloudových řešení",
			iconName: digi,
			show: true,
			href: getDigitalizationAndAutomationPath(tenant),
		},
		{
			title: "Vývoj a tvorba webů",
			iconName: integration,
			show: true,
			href: getWebsitesPath(tenant),
		},
		{
			title: "Vývoj embedded software",
			iconName: integration,
			show: false,
			href: getEmbeddedSoftwarePath(tenant),
		},
		{
			title: "CRM",
			iconName: integration,
			show: true,
			href: getCrmPath(tenant),
		},
	];
}
